module.exports = __webpack_public_path__ + "static/media/tm-colorit-3.e9dc88cb.webp";